export const BRAND_CONSTRAINTS = {
    name: { maxLength: 100, label: 'Brand name' },
};
//# sourceMappingURL=constraints.js.map